<template>
  <div>
    <loading v-show="showLoader" />

    <div class="ib-main-section">
      <div class="container">
        <router-link class="ib-back-btn" :to="{ name: 'Home' }">Back</router-link>
        <div class="row">
          <div class="col-md-6 pl-0">
            <div class="d2c-class-container" style="padding-top: 77px;">
              <!-- Nav tabs -->
              <h2 class="listing-page-title">Recent Search</h2>
            </div>
          </div>
          <div class="col-md-6 in-page-infographic">
            <img class="img-fluid" alt="icon" :src="require('@/assets/images/claim-policy-right-img.svg')" />
          </div>
        </div>
      </div>

      <div class="container ib-p-0 article-box">
        <div class="row">
          <div class="col-sm-12" v-for="(product, index) in recentSearchProducts" :key="'filteredproducts' + index">
            <div class="in-search-card">
              <div class="in-search-img">
                <img alt="icon" class="img-fluid" :src="product.plan_logo" v-if="product.plan_name != ''" />
                <img alt="icon" class="img-fluid" :src="product.product_logo" v-else />
                <div class="in-absolute-icon">
                  <img alt="icon" class="img-fluid in-search-icon" :src="product.company_logo" />
                </div>
              </div>
              <div style="flex:1;">
                <div class="ib-card-title">{{product.company_name}}<span class="ib-card-subtitle">{{ product.subclass_name }}</span></div>
                <div class="ib-card-plan" style="width: max-content !important;" v-if="product.plan_name == ''">{{product.product_name}}</div>
                <div class="ib-card-plan" style="width: max-content !important;" v-if="product.plan_name != ''">{{product.plan_name}}</div>
              </div>

              <div class="d-flex">
                <div class="pr-1">
                  <button class="ib-btn-primary ib-btn-hover" @click="buyProduct(product)">Buy&nbsp;Now</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loading from '@/components/Loading/Loading';

export default {
  name: 'RecentSearch',
  data() {
    return {
      showLoader: false,
      recentSearchProducts: {}
    }
  },
  components: {
    loading
  },
  created() {
    const self = this;
    self.getWishlistData();
  },
  methods: {
    async getWishlistData() {
      const self = this;

      self.showLoader = true;
      await axios.get('recent_search').then(function (resp) {
        self.showLoader = false;
        if(resp.data.code == 200) {
          self.recentSearchProducts = resp.data.data;
        } else {
          $toast.error(resp.data.message, { position: 'top-right' });
          return false;
        }
      }).catch(function (error) {
        self.showLoader = false;
        if(error.data.errors != undefined) {
          error.data.errors.forEach(element => {
            $toast.error(element.message, { position: 'top-right' });
          });
        } else {
          $toast.error(error.data.message, { position: 'top-right' });
        }
      })
    },
    buyProduct(product) {
      const self = this;
      self.$router.push({ name: 'Acquisition', params: { classId: product.mainclass_id }, query : { redirectFor :'recentSearch', productId: product.id} });
    }
  }
}
</script>
<style scoped>
/* .position-relative .small-icon {
    border-radius: 50%;
    position: absolute;
    width: 25px;
    height: 25px;
    top: -20px;
    right: 14px;
    border: 0.063rem solid gainsboro;
}
@media (max-width:992px) {
  .ib-card {
    width: 90% !important;
    margin:0 auto 1.25rem !important;
  }
} */
.in-search-card{
  width: 100%;
  min-height: 100px;
  padding: 15px 10px;
  border-radius: 10px;
  border: solid 1px rgba(55, 141, 171, 0.25);
  background-color: #fff;
  margin-bottom: 1rem;
  display: flex;
  flex-flow: row wrap;
}
.in-search-img {
  width: 79px;
  height: 66px;
  padding: 13px;
  border-radius: 11px;
  background-color: #ecf3f5;
  position: relative;
  margin-right: 25px;
}
.in-search-icon{
  width: 30px;
  height: 30px;
  padding: 2px 1px 2px 2px;
  border: solid 1px #3d9cbd;
  border-radius: 50%;
  background-color: #ecf3f5;
}
.in-absolute-icon{
    position: absolute;
    right: -10px;
    bottom: -10px;
}
@media (max-width:550px){
  .in-search-card{
    width: 90%;
    margin: 0 auto 1rem;
  }
  .in-search-img {
    min-width: 80px;
    margin-bottom: 25px;
}
}
</style>



// WEBPACK FOOTER //
// src/views/RecentSearch/Index.vue